import axios from 'axios';
import React, { useEffect, useState } from 'react';

function Contact() {
  const [owners, setOwners] = useState([]);
  const getData = async () => {
    try {
      const result = await axios.get(`${process.env.REACT_APP_DNAME}/getowners`);
      if (result && result.data) {
        setOwners(result.data);
      } else {
        setOwners([]);
      }
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const targetSite = 'Satta Bazar';
  const filteredOwners = owners.filter(o => !o.website || o.website === targetSite || o.website === 'Both');

  return (
    <div className=" flex flex-col justify-center items-center m-2 gap-4">
      {filteredOwners.length > 0 ? (
        filteredOwners.map((owner, idx) => (
          <div key={idx} className="w-full md:w-2/4 border-dashed rounded-3xl bg-gradient-to-r from-cyan-300 to-white border-4 p-2 text-xl border-blue-600 text-center">
            <p>
              <strong>🙏🏿नमस्कार साथियो 🙏🏿</strong>
            </p>
            <p>
              <strong>
                अपनी गेम का रिजल्ट हमारी web साइट पर लगवाने के लिए संपर्क
                करें।&nbsp; &nbsp;
              </strong>
            </p>
            <p>
              <strong>----{owner.name || 'DevaBhai'}----</strong>
            </p>

            {owner.phoneNo && (
              <div className="flex justify-center items-center mt-4">
                <a
                  className="hover:text-blue-800"
                  target="_blank"
                  rel="noreferrer"
                  href={`https://wa.me/${owner.phoneNo}`}
                >
                  <strong> 👉https://wa.me/{owner.phoneNo} </strong>
                </a>
              </div>
            )}

            <div className=" h-20 flex justify-center items-center">
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://wa.me/${owner.phoneNo}`}
                id={`body_contactwa_${idx}`}
              >
                <strong>
                    <img
                      className="rounded-full h-16 w-16 object-cover"
                      loading="lazy"
                      src={require("./logo.png")}
                      alt="Whatsapp to show game on this website"
                    />
                </strong>
              </a>
            </div>

            <p className="text-sm">
              NOTE: &nbsp; इस नंबर पर लीक गेम नही मिलता गेम लेने वाले भाई कॉल या
              मैसेज न करें।
            </p>
          </div>
        ))
      ) : null}
    </div>
  );
}

export default Contact;
